import React, { useState, useEffect } from 'react';
import { Button } from '@material-ui/core';
import { LedgerPdf } from '../../../components/ledger/LedgerPdf';
import { TLedger, TLedgerPictur } from '../../../types/Ledger';
import {
  createLedger,
  updateLedger,
  getClient
} from '../../../apicalls/ledger';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { ImageItem } from './ImageItem';
import { reorder } from '../../../utils/estimate';
import { formatDatetime, checkResData } from '../../../utils/common';
import { userTenant, progressFlgState } from '../../../GlobalState';
import { useRecoilValue, useRecoilState } from 'recoil';
import { TTenant } from '../../../types/common';
import { useSnackbar } from 'notistack';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Height } from '@material-ui/icons';

type Tprops = {
  register: any;
  setValue: any;
  handleSubmit: any;
  getValues: any;
  watch: any;
  photoLedgerId?: number;
  errors: any;
  changeLoggedInData: (newData: string) => void;
};

export const PictureList: React.FC<Tprops> = (props: Tprops) => {
  const {
    register,
    setValue,
    handleSubmit,
    getValues,
    photoLedgerId,
    errors,
    watch,
    changeLoggedInData
  } = props;

  const userTenantData = useRecoilValue<TTenant | undefined>(userTenant);
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const [pdfDownlardFlg, setPdfDownlardFlg] = useState<boolean>(true);
  const [clientName, setClientName] = useState<string>('');
  const { enqueueSnackbar } = useSnackbar();
  const [imageData, setImageData] = useState<TLedgerPictur[]>();

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDownScreen = useMediaQuery(theme.breakpoints.up('md'));

  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const arrangedItem: any = reorder(
      imageData,
      result.source.index,
      result.destination.index
    );
    setValue('pictures', arrangedItem);
  };

  const onSubmit = (data: TLedger) => {
    setProgressFlg(true);
    if (photoLedgerId) {
      updateLedger(data).then((resData: any) => {
        checkResData(resData, enqueueSnackbar, changeLoggedInData).then(
          (data: any) => {
            creactPdf();
          }
        );
      });
    } else {
      createLedger(data).then((resData: any) => {
        checkResData(resData, enqueueSnackbar, changeLoggedInData).then(
          (data: any) => {
            creactPdf();
          }
        );
      });
    }
  };

  useEffect(() => {
    if (imageData && imageData.length > 0) {
      setPdfDownlardFlg(false);
    } else {
      setPdfDownlardFlg(true);
    }
  }, [imageData?.length]);

  useEffect(() => {
    const constructId = getValues('construct_id');
    if (constructId) {
      getClient(constructId).then(data => {
        setClientName(data.client_name);
      });
    }
  }, [getValues('construct_id')]);

  useEffect(() => {
    setImageData(getValues('pictures'));
  }, [watch('pictures')]);

  const creactPdf = async () => {
    const ledger = getValues();
    const blob = await LedgerPdf(ledger, userTenantData);
    if (blob) {
      const currentDatetime = formatDatetime(new Date(), 'YYYYMMDD');
      const fileName = `写真台帳_${currentDatetime}.pdf`;
      const link = document.createElement('a');
      link.download = fileName;
      link.href = URL.createObjectURL(blob);
      link.click();
    }
    setProgressFlg(false);
  };

  return (
    <div
      style={{ display: 'flex', justifyContent: 'flex-start', width: '70%' }}
    >
      <div style={{ backgroundColor: 'white', width: '100%' }}>
        <div style={{ padding: 10, backgroundColor: 'white' }}>
          <div style={{ fontSize: 20, fontWeight: 'bold', margin: '7px 0' }}>
            {getValues('construct_name')}
          </div>
          <div style={{ fontSize: 14, color: '#808080' }}>{clientName}</div>

          <div
            style={{
              display: 'flex',
              margin: '20px 0',
              flexDirection: isMdDownScreen ? 'row' : 'column'
            }}
          >
            <div>
              <span
                style={{ width: 130, display: 'flex', alignItems: 'center' }}
              >
                台帳タイトル
              </span>
            </div>
            <div style={{ padding: '5px 0' }}>
              <input
                type='text'
                style={{ height: 35, width: isMdDownScreen ? 400 : '100%' }}
                {...register('title', {
                  required: {
                    value: true,
                    message: '台帳タイトルは必須です。'
                  },
                  maxLength: {
                    value: 100,
                    message: '台帳タイトルは100文字以内で入力してください。'
                  }
                })}
              />
              {errors.title && (
                <div style={{ fontSize: 12, color: 'red' }}>
                  {errors.title.message}
                </div>
              )}
            </div>
            <Button
              style={{
                backgroundColor: '#52555F',
                color: '#fff',
                marginRight: 10,
                margin: '0 0 0 auto'
              }}
              variant='contained'
              color='secondary'
              disabled={pdfDownlardFlg}
              onClick={handleSubmit(onSubmit)}
            >
              PDFダウンロード
            </Button>
          </div>
        </div>
        <div style={{ borderTop: 'solid 1px lightgray', padding: 10 }}>
          写真{imageData && imageData.length > 0 ? imageData.length : 0}枚
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId='droppable'>
            {provided => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {imageData && imageData.length > 0 ? (
                  <>
                    {imageData.map((item: TLedgerPictur, index) => (
                      <Draggable
                        draggableId={index.toString()}
                        index={index}
                        key={`PictureList_${index}`}
                      >
                        {provided => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <ImageItem
                              item={item}
                              index={index}
                              register={register}
                              setValue={setValue}
                              imageData={imageData}
                              errors={errors}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))}
                  </>
                ) : (
                  <div style={{ textAlign: 'center', marginTop: 50 }}>
                    写真が選択されていません
                  </div>
                )}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  );
};
